var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHomeinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 23v-7H9v7H4a1 1 0 0 1-1-1V7.52l9-6.3 9 6.3V22a1 1 0 0 1-1 1h-5ZM2 7v15a2 2 0 0 0 2 2h6v-7h4v7h6a2 2 0 0 0 2-2V7L12 0 7 3.5V1H2v6Zm4-2.8V2H3v4.3l3-2.1Z",
  fill: "#252829"
})));
export default SvgHomeinline;